export default __webpack_public_path__ + "static/media/Screenshot_1619919011.0aed6d11.png";